import React from 'react';
import { Box } from '@mui/material';
import { useInstatDesign } from '../theme/instatDesign';

/**
 * iOS-style card surface: pure white, very soft shadow, large radius.
 * `hover` adds a gentle lift on hover (use for clickable cards).
 * `tone="glass"` renders a frosted translucent surface (for sticky bars).
 */
export default function Card({
  children,
  hover = false,
  tone = 'solid', // 'solid' | 'alt' | 'glass' | 'ghost'
  padding = 3,
  radius,
  sx = {},
  ...rest
}) {
  const d = useInstatDesign();
  const r = radius != null ? radius : d.radius.xl;

  const tones = {
    solid:  { bg: d.colors.surface,       shadow: d.shadows.card,  border: 'none' },
    alt:    { bg: d.colors.surfaceAlt,    shadow: 'none',          border: `1px solid ${d.colors.divider}` },
    glass:  { bg: d.colors.surfaceOverlay, shadow: d.shadows.glass, border: `1px solid ${d.colors.divider}` },
    ghost:  { bg: 'transparent',          shadow: 'none',          border: `1px solid ${d.colors.divider}` },
  };
  const t = tones[tone] || tones.solid;

  return (
    <Box
      sx={{
        bgcolor: t.bg,
        borderRadius: `${r}px`,
        boxShadow: t.shadow,
        border: t.border,
        p: padding,
        backdropFilter: tone === 'glass' ? 'saturate(180%) blur(20px)' : 'none',
        WebkitBackdropFilter: tone === 'glass' ? 'saturate(180%) blur(20px)' : 'none',
        transition: `box-shadow ${d.motion.base}, transform ${d.motion.base}`,
        ...(hover && {
          cursor: 'pointer',
          '&:hover': {
            boxShadow: d.shadows.cardHover,
            transform: 'translateY(-2px)',
          },
        }),
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
